import * as React from 'react'
import SVGUniqueID from 'react-svg-unique-id'

interface Props {
  width: number
  height: number
  fill: string
}

const BackArrowIcon = (props: Props) => {
  const { width, height, fill } = props
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.974 15.683a.618.618 0 0 1-.441-.183l-5.059-5.058a.629.629 0 0 1 0-.884L7.533 4.5a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883L3.799 10l4.617 4.617a.629.629 0 0 1 0 .883.605.605 0 0 1-.442.183Z"
          fill={fill}
        />
        <path
          d="M17.084 10.625H3.059A.63.63 0 0 1 2.434 10a.63.63 0 0 1 .625-.625h14.025a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
          fill={fill}
        />
      </svg>
    </SVGUniqueID>
  )
}

BackArrowIcon.defaultProps = {
  height: 20,
  width: 20,
  fill: '#475569'
}

export { BackArrowIcon }
